module Meevo.Components.FileUpload {
    'use strict';

    import MeevoFile = Meevo.Model.MeevoFile;

    interface IFileUploadScope extends ng.IScope {
        fileType: string;
        meevoFile: MeevoFile;
        fileGuid: string;
        isStorageUpdated?: number;
        ngDisabled?: boolean;
        showMultipleModals?: boolean;
        mimeType?: string;
        templateMetaData?: string;
        allowToRemove?: boolean;
        removeButtonType?: string;
        removeButtonMaxWidth: number;
        openUploadDialog: () => void;
        deleteItem: () => void;
        aspectRatio?: number;
        additionalInstruction?: string;
    }

    export class MeevoFileUpload implements angular.IDirective {
        restrict = 'A';

        scope = {
            fileType: '=',
            meevoFile: '=',
            fileGuid: '=',
            isStorageUpdated: '=?',
            templateMetaData: '=?',
            ngDisabled: '=?',
            mimeType: '=?',
            allowToRemove: '=?',
            model: '=?ngModel',
            removeButtonType: '@?',
            aspectRatio: '<?',
            additionalInstruction: '@?',
            fileData: '=?',
            updateGuid: '=?',
            showMultipleModals: '=?'
        };

        link = (scope: IFileUploadScope, elem: JQuery, attrs: angular.IAttributes) => {
            let deleteButtonAdded = false;
            scope.allowToRemove = typeof scope.allowToRemove === 'undefined' ? true : scope.allowToRemove;
            scope.removeButtonType = scope.removeButtonType || 'circle';
            scope.removeButtonMaxWidth = elem.width() + 5 < 140 ? elem.width() + 5 : 140;

                scope.openUploadDialog = (): void => {
                    let options = {
                        scope: scope,
                        templateUrl: 'app/components/fileUpload/fileUploadModalTemplate.html',
                        controller: 'meevo.components.fileupload.FileUploadModalController',
                        controllerAs: 'vm',
                        preserveScope: true,
                        skipHide: true,
                        multiple: true,
                        additionalClassName: 'file-upload-modal',
                    };
                    this.$mdDialog.show(options);
                };

            scope.deleteItem = (): void => {
                this.modalService.warning('MESSAGE_DELETE_CONFIRMATION', 0, !!scope.showMultipleModals, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' }).then((confirmResult: boolean) => {
                    if (confirmResult) {
                        scope.fileGuid = null;
                        scope.templateMetaData = null;
                        scope.isStorageUpdated = 1;
                        delete scope.meevoFile.files;
                    }
                });
            };

            elem.bind('touchstart click', function (): void {
                if (!scope.ngDisabled) {
                    scope.openUploadDialog();
                }
            });

            scope.$watch('fileGuid', () => {

                if (!deleteButtonAdded && scope.allowToRemove && scope.fileGuid && scope.meevoFile && Array.isArray(scope.meevoFile.files) && scope.meevoFile.files.length > 0) {
                    deleteButtonAdded = true;
                    this.$templateRequest('app/components/fileUpload/fileUploadDeleteButton.html').then(tpl => {
                        let template = angular.element(tpl);
                            // detect the type of the element with the directive
                            switch (elem.prop('tagName')) {
                                // if meevo-file-upload used on DIV element
                                case 'DIV':

                                    // there are a cases when DIV element has a button or img inside of it.
                                    if (elem.find('button').length > 0 || elem.find('img').length > 0) {
                                        this.$compile(template)(scope).insertAfter(elem);

                                    } else {
                                        elem.append(this.$compile(template)(scope));
                                    }
                                    break;
                                case 'IMG':
                                    elem.parent().css({
                                        display: 'flex',
                                        'flex-direction': 'column'
                                    });
                                    elem.parent().append(this.$compile(template)(scope));
                                    break;
                                default:
                                    elem.append(this.$compile(template)(scope));
                            }
                    });

                }
            });
        };

        constructor(
            private $mdDialog: ng.material.IDialogService,
            private $templateRequest: ng.ITemplateRequestService,
            private $compile: ng.ICompileService,
            private $timeout: ng.ITimeoutService,
            private meevoFileUploadService: MeevoFileUploadService,
            private modalService: Meevo.Components.Modal.IModalService
        ) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($mdDialog: ng.material.IDialogService,
                             $templateRequest: ng.ITemplateRequestService,
                             $compile: ng.ICompileService,
                             $timeout: ng.ITimeoutService,
                             meevoFileUploadService: MeevoFileUploadService,
                             modalService: Meevo.Components.Modal.IModalService
            ) => {
                return new MeevoFileUpload($mdDialog, $templateRequest, $compile, $timeout, meevoFileUploadService, modalService);
            };
            directive.$inject = [
                '$mdDialog',
                '$templateRequest',
                '$compile',
                '$timeout',
                'meevo.components.fileupload.MeevoFileUploadService',
                'meevo.components.modal.ModalService',
            ];
            return directive;
        }
    }

    angular.module('meevo.components.fileupload')
        .directive('meevoFileUpload', MeevoFileUpload.factory());
}
